import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const GET_PROPERTY_TYPE_API = `${LOCAL_URL}/property/propertyType`
export const GET_CARPET_AREA_UNIT_API = `${LOCAL_URL}/property/carpetAreaUnit`
export const GET_COUNTRY_API = `${LOCAL_URL}/getCountry`
export const GET_PROVINCE_API = `${LOCAL_URL}/getProvince`
export const GET_SEARCH_VALUE_API = `${LOCAL_URL}/admin/searchPropertyAdmin`


//get admin property list
export const List_Property_API = `${LOCAL_URL}/admin/listPropertyAdmin`

//get user list

export const List_User_API = `${LOCAL_URL}/admin/user/listUsers`

//search Api
export const Search_API = `${LOCAL_URL}/admin/searchUserAdmin`

const headers = {
  Authorization: API_TOKEN,
  //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
}

// axios request to get all property
export async function list_Property(obj: any) {
  let data = {
    page: obj,
  }
  return await axios.post(List_Property_API, data)
}

export async function Get_Property_Type() {
  const headers = {
    Authorization: API_TOKEN,
    //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
  }
  return await axios.post(
    GET_PROPERTY_TYPE_API,

    {
      headers,
    }
  )
}

// function to get carpet area unit
export async function Get_Carpet_Unit() {
  const headers = {
    Authorization: API_TOKEN,
    // 'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
  }
  return await axios.post(
    GET_CARPET_AREA_UNIT_API,

    {
      headers,
    }
  )
}

// function get country

export async function Get_Country() {
  return await axios.get(GET_COUNTRY_API)
}

// FUNCTION  TO GET Province

export async function Get_Province(country_id: number) {
  return await axios.post(GET_PROVINCE_API, {country_id})
}

//axios call to search email id '

export async function Search(email_id: string) {
  return await axios.post(Search_API, {email_id})
}

// address and proptitle words search

export async function CommonSearchValue(query:any,currentSearchPage:number){

  let data ={
    search:query,
    page:currentSearchPage
  }
  const headers = {
    Authorization: API_TOKEN,
    //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
  }
console.log("fhs>>>>>>",data)
 return await axios.post(GET_SEARCH_VALUE_API,data, {
  headers,
}
  )
  // console.log("api valuye",data)
  // console.log("--------------->",response)
  // return response;

}



